import React from 'react'
import { shallow } from 'enzyme'
import { Pane } from '../Pane'

describe('Pane', () => {
  let wrapper, props, result

  const docProps = {
    skipped: false,
    confirmed: false,
    status: 'pending_review',
    uploaded: false,
    skippable: false,
    referenceFiles: "[]",
    adminOnly: false,
    deletable: false,
    displayCommentable: false,
    esignable: false,
    live: true,
    rid: 123,
    title: 'title',
    type: 'Document',
    files: [
      {
        is_new: false,
        name: 'foo.jpg'
      }
    ]
  }

  beforeAll( () => {
    props = {
      handedOff: true,
      entityId: 1,
      handedOff: true,
      resourceType: 'Business',
      data: {
        loan: {
          businesses: [{
            rid: 1,
            borrowerType: 'oc',
            name: 'name',
            guarantors: [
              {
                documents: [],
                name: 'name',
                rid: 2
              }
            ],
            documents: [{...docProps}]
          }],
          affiliates: []
        }
      },
      loanId: 22,
      superUser: false,
      canComment: false,
      bankAdmin: false,
      customerService: true,
      idx: 123,
      client: {
        resetStore: () => {
          result = 'resetStore'
        }
      }
    }
    wrapper = shallow(<Pane {...props} />)
  })

  describe('#renderCategories', () => {
    it('should return obj', () => {
      const obj = wrapper.instance().renderCategories()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#renderTitle', () => {
    it('should return obj', () => {
      const obj = wrapper.instance().renderTitle()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#resetClientStore', () => {
    it('should return obj', () => {
      wrapper.instance().resetClientStore()
      expect(result).toBe('resetStore')
    })
  })
})